import React from 'react';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { acme } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

const SIZE_MAP = {
  sm: { py: 1, px: 1.25, img: 16, radius: acme.radius.sm },
  md: { py: 1.25, px: 1.5, img: 18, radius: acme.radius.md },
  lg: { py: 2.25, px: 2, img: 18, radius: acme.radius.lg },
};

/**
 * Logo mark — default: black pill bar (sidebar/nav). plain: logo only, no background.
 */
export default function BrandLogoMark({
  to = '/',
  size = 'md',
  variant = 'default',
  src = '/images/logo.svg',
  alt = 'Mailsball',
  sx,
}) {
  const s = SIZE_MAP[size] || SIZE_MAP.md;
  const isPlain = variant === 'plain';

  return (
    <Box
      component={Link}
      to={to}
      sx={mergeSx(
        {
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          flexShrink: 0,
          ...(isPlain
            ? { backgroundColor: 'transparent', borderRadius: 0, py: 0, px: 0 }
            : {
                backgroundColor: acme.colors.foreground,
                borderRadius: s.radius,
                py: s.py,
                px: s.px,
              }),
        },
        sx,
      )}
    >
      <img src={src} alt={alt} style={{ height: s.img, display: 'block' }} />
    </Box>
  );
}
